import Vue from "vue";
import routes from "./routes/index.js";
import storeModule from "./store-module/index.js";
import login from "./utils/login.js";
export default {
    routes: routes,
    storeModule: storeModule,
    login,
    main() {
        let userAgent = window.navigator.userAgent;
        if (
            userAgent.indexOf("Android") > -1 ||
            /source=SWTP/.test(location.href)
        ) {
            Vue.prototype.$showTitle = true;
        } else {
            Vue.prototype.$showTitle = false;
        }
        Vue.prototype.$bindInsurance = function(from) {
            this.$router.push(
                `/bind-policy-in-h5?keepScroll=true&from=${from ||
                    location.hash.replace("#/", "")}`
            );
        };
    },
};
